import React, {useState} from 'react';
import classnames from 'classnames';
import {Button, Modal} from 'react-bootstrap';
import {FormattedMessage, useIntl} from 'react-intl';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';
import {Form, Formik} from 'formik';
import moment from 'moment';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import GeneralDetailsUnit from './GeneralDetailsUnit';
import GridUnit from './GridUnit';
import SummaryDetailsUnit from './SummaryDetailsUnit';
import * as popupActions from '../../_redux/popupEditRowDataActions';
import * as invoiceOrdersActions from '../../_redux/invoiceOrdersActions';
import can from '../../../_common/components/Permissions/can';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';
import {showGlobalMessage} from '../../../_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../../../../../_metronic/i18n/messages';
import {checkArrayGetSum} from '../../utils/checkArrayGetSum';

const EditRowForm = ({
                       viewMode,
                       handleCloseModal,
                       canCreate,
                       allowInvoiceDeal
                     }) => {
  const dispatch = useDispatch();
  const valuesSet = {
    days: '',
    hours: '',
    description: '',
    amount: '',
    vatIncluded: false,
  };
  const {currentState} = useSelector(
    (state) => ({currentState: state['popupEditRowData']}),
    shallowEqual
  );
  const {entities, dataLoading} = currentState;
  const {
    customerName,
    createdAt,
    contact,
    idNumber,
    phone,
    address,
    emailRecipients,
    lines,
    _id
  } = entities;
  const {currentState: rowState} = useSelector((state) => ({currentState: state.invoiceOrdersEditAndSend}), shallowEqual);
  const {entities: rowEntities, dataLoading: rowDataLoading} = rowState;
  const filteredRowEntities = rowEntities
    ? rowEntities.filter(item => item._id === _id)
    : [];
  const agentData = filteredRowEntities.length > 0
    ? ` ${filteredRowEntities[0]?.agentName} ${filteredRowEntities[0]?.agentID} `
    : '';

  const linesData = lines.map((item, index) => {
    return {
      days: lines[index].days ? parseFloat(lines[index].days) : 0,
      hours: lines[index].hours ? parseFloat(lines[index].hours) : 0,
      description: lines[index].description || '',
      vatIncluded: lines[index].vatIncluded || false,
      amount: lines[index].amount
        ? (parseFloat(lines[index].amount)).toFixed(2)
        : 0,
    };
  });
  const initialValues = {
    invoiceOrderID: _id || '',
    invoiceOrderData: {
      createdAt: Boolean(createdAt)
        ? dayjs(createdAt)
        : null,
      customerName: customerName || '',
      contact: contact || '',
      idNumber: idNumber || '',
      phone: phone || '',
      address: address || '',
      emailRecipients: emailRecipients || '',
      lines: linesData,
    },
  };

  const editInvoiceOrder = (formValues, sendToRivhit) => async () => {
    try {
      const invoiceOrder = _.cloneDeep(formValues);
      invoiceOrder.invoiceOrderData.createdAt = Date.parse(moment(formValues.invoiceOrderData.createdAt.$d));
      invoiceOrder.invoiceOrderData.lines = invoiceOrder.invoiceOrderData.lines.map(line => {
        return {...line, amount: parseFloat(line.amount)};
      });
      invoiceOrder.sendToRivhit = sendToRivhit;
      await dispatch(popupActions.editRowData(invoiceOrder, filteredRowEntities[0].agentID));

      if (sendToRivhit) {
        await dispatch(invoiceOrdersActions.sendInvoiceOrdersToRivhit(
          [invoiceOrder.invoiceOrderID],
          checkArrayGetSum(invoiceOrder?.invoiceOrderData?.lines),
          invoiceOrder?.invoiceOrderData?.createdAt ? moment(invoiceOrder?.invoiceOrderData?.createdAt).format('DD-MM-YYYY') : '',
          filteredRowEntities[0]?.agentID
        ));
      }
      await dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
    } catch (err) {
      await dispatch(showGlobalMessage(M['-1']));
    } finally {
      await handleCloseModal();
    }
  };
  const [valid, setValid] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => null}
      enableReinitialize={true}
    >
      {({values, setFieldValue}) => (
        <Form>
          {(!dataLoading && !rowDataLoading)
            ? (
              <div>
                <h3 className="card-title font-weight-bold text-dark text-center mb-2">
                  <FormattedMessage id="invoice-orders-popup-edit-details" defaultMessage="Invoice order details"/>
                  {agentData}
                </h3>
                <GeneralDetailsUnit
                  values={values.invoiceOrderData}
                  setFieldValue={setFieldValue}
                  viewMode={viewMode}
                  setValid={setValid}
                />
                <GridUnit values={values} valuesSet={valuesSet} viewMode={viewMode}/>
                <SummaryDetailsUnit
                  lines={values.invoiceOrderData.lines}
                  date={new Date(values.invoiceOrderData.createdAt)}
                />
              </div>
            )
            : (
              <div className="spinner-container popup-edit-row-content">
                <span className="spinner spinner-md spinner-primary"/>
              </div>
            )}
          <div className="d-flex justify-content-center mt-6">
            <Button
              className="btn-secondary btn-sm mx-2 w-120px"
              onClick={handleCloseModal}
            >
              <FormattedMessage id="invoices-popup-buttonCancel" defaultMessage="Cancel"/>
            </Button>
            {!viewMode &&
              <Button
                className="btn-sm mx-2 custom-send-button w-120px"
                onClick={editInvoiceOrder(values, false)}
                type="submit"
              >
                <FormattedMessage id="invoice-orders-popup-edit-buttonSave" defaultMessage="Save"/>
              </Button>
            }
            {!viewMode &&
              <Button
                className="btn-sm mx-2 custom-send-button w-120px"
                onClick={editInvoiceOrder(values, true)}
                type="submit"
                disabled={!canCreate || !valid || !allowInvoiceDeal}
              >
                <FormattedMessage id="invoice-orders-popup-edit-buttonSaveSend" defaultMessage="Save and send"/>
              </Button>
            }
          </div>
        </Form>
      )}
    </Formik>
  );
};

const PopupEditRow = ({
                        viewMode = false,
                        canCreate,
                        allowInvoiceDeal,
                        status,
                        invoiceOrderID,
                      }) => {
  const {formatMessage} = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);

  const tooltip = viewMode
    ? formatMessage({id: 'invoice-orders-button-tooltip-view', defaultMessage: 'View invoice order',})
    : formatMessage({id: 'invoice-orders-button-tooltip-edit', defaultMessage: 'Editing before sending'});
  const buttonIsEnabled = (status === 0 || status === 1 || status === 4) && can('full', 'invoiceOrders');
  const buttonClassName = classnames(
    'btn btn-icon btn-light btn-sm custom-action-button',
    {['custom-disabled-button cursor-default']: !buttonIsEnabled && !viewMode}
  );

  const getInvoiceOrder = (id) => {
    dispatch(popupActions.getPopupEditRowData(id));
    handleShowModal();
  };

  return (
    <>
      <Button
        className={buttonClassName}
        title={tooltip}
        disabled={!buttonIsEnabled && !viewMode}
        onClick={() => getInvoiceOrder(invoiceOrderID)}
      >
        {viewMode
          ? <img src={toAbsoluteUrl('/media/svg/Search_brandColor.svg')} alt="view"/>
          : <img src={toAbsoluteUrl('/media/svg/WriteBrandColor.svg')} alt="edit"/>
        }
      </Button>
      <Modal show={show} onHide={handleCloseModal} className={'popupEditRowContainer'}>
        <Modal.Body>
          <EditRowForm
            viewMode={viewMode}
            handleCloseModal={handleCloseModal}
            canCreate={canCreate}
            allowInvoiceDeal={allowInvoiceDeal}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupEditRow;